import toast from 'react-hot-toast';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../../../constants/ActionNameConstants';
import { GET_CGA_CLIENT_LIST_API_URL } from '../../../../../constants/ApiUrlConstants';
import { getApiRequest } from '../../../../../features/axiosClient';
import { cgaClientListFailure, cgaClientListSuccess } from '../actions';

const cgaClientListAPI = (action) =>
  getApiRequest(`${GET_CGA_CLIENT_LIST_API_URL}`);

function* handleFilesFilterAPI(action) {
  try {
    const response = yield call(cgaClientListAPI, action.payload);
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    if(response.data.success){
        yield put(cgaClientListSuccess(JSON.parse(response.data.value)));
    }
    else{
        yield put(cgaClientListFailure(response?.data?.errorMessage));
    }
  } catch (error) {
    yield put(cgaClientListFailure(error));
  }
}

export function* watchCGAClientList() {
  yield takeLatest(types.GET_CGA_CLIENT_LIST_REQUEST, handleFilesFilterAPI);
}
